import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import defaults from './hermesPage/default/main.vue'
const routes = [
  {
    path: '/xiangdao',
    name: 'xiangdao',
    component: () => import(/* webpackChunkName: "xiangdao" */ './hermesPage/xiangdao/main.vue')
  },
{
    path: '/ruqi',
    name: 'ruqi',
    component: () => import(/* webpackChunkName: "ruqi" */ './hermesPage/ruqi/main.vue')
  },
{
    path: '/T3',
    name: 'T3',
    component: () => import(/* webpackChunkName: "T3" */ './hermesPage/T3/main.vue')
  },
{
    path: '/:pathMatch(.*)*',
    name: 'default',
    component: defaults
  }
]

const router = new Router({
  base: '/web-10d622d',
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0, y: 0
    }
  }
})
  
router.beforeEach((to, from, next) => {
  document.body.style.overflow = ''
  next()
})

export default router
